import Detail from "./Detail";
import {Route, Routes} from "react-router-dom";
import List from "./List";
import Edit from "./Edit";
import {RouterProps} from "../../../RouterProps";

export default function ItemRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/post'} element={<Edit {...props} />} />
            <Route path={'/:envFaqItemId'} element={<Detail {...props} />} />
            <Route path={'/:envFaqItemId/edit'} element={<Edit {...props} />} />
        </Routes>
    </>
}